<template>
  <div class="Services">
    <div class="content-info">
      <p class="o-b t-i">Servicios registrados</p>
      <div class="b-c">
        <div class="c-t-info">
          <table class="table table-light m-top">
            <thead>
              <tr>
                <th scope="col">Categoría</th>
                <th scope="col">Subcategoría</th>
                <th scope="col">Precio</th>
                <th scope="col">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="service in services" :key="service.id">
                <td>{{ service.category.name }}</td>
                <td>{{ service.name }}</td>
                <td>${{ service.price }}</td>
                <td>
                  off
                  <toggle-button
                    :value="service.enabled"
                    :sync="true"
                    :color="{
                      checked: '#75C791',
                      unchecked: '#000',
                      disabled: '#CCCCCC',
                    }"
                    @change="changeStatus(service, $event)"
                  />
                  on
                </td>
                <td>
                  <button @click="changePrice(service)">Editar precio</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Category from '../parse/models/Category'
import Service from '../parse/models/Service'

export default {
  name: 'Services',
  data() {
    return {
      services: [],
    }
  },
  async beforeMount() {
    this.categories = await Category.load()
    this.services = await Service.load()
  },
  methods: {
    async changeStatus(service, event) {
      let response = await this.$swal({
        title: 'Espera',
        text: service.enabled ? '¿Estás seguro que quieres pausar la disponibilidad del servicio?' : '¿Estás seguro que quieres activar este servicio?',
        type: 'warning',
        confirmButtonText: 'Cambiar',
        showCloseButton: true
      })

      if (!response.value) return

      await service.toggleBlock()
      this.$swal('', 'Se actualizó el servicio', 'success')
      this.reload()
    },
    reload() {
      this.$forceUpdate()
    },
    async changePrice(service) {
      let result = await this.$swal({
        title: 'Ingresa el nuevo precio en MXN',
        input: 'number',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
      })

      if (!result.isConfirmed) return

      let { value: confirm } = await this.$swal({
        title: 'Espera',
        text: `¿Estás seguro que quieres cambiar el precio del servicio (${service.category.name}) ${service.name} a $${Number(result.value).toFixed(2)}?`,
        type: 'warning',
        confirmButtonText: 'Cambiar',
        showCloseButton: true
      })

      if (!confirm) return

      await service.changePrice(Number(result.value))
      this.$swal('', 'Se actualizó el servicio', 'success')
      this.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.c-t-info {
  width: 100%;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.c-t-info-h-active {
  height: auto;
}

/* USER INFO */
.img_user {
  width: 138px;
  height: 138px;
  border-radius: 70px;
  float: left;
  margin-right: 20px;
}

.info-u {
  display: inline;
}

.info-ac button {
  display: inline;
}

table tbody tr {
  background: #f3f3f3;
}

.but-r {
  background: #e96369;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
}

.but-r:hover {
  background: rgb(231, 76, 84);
}

.but-c {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 270px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
}

.but-c:hover {
  background: #14fc78;
}

.m-r {
  margin-right: 50px;
}

.dropdown-menu {
  width: 120px;
}

/* Container */

.content-info {
  margin-left: 310px;
  margin-right: 50px;
}

.c-i-c {
  width: 300px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 20px;
}

.t-u-c {
  padding-top: 14px;
  color: #fff;
  font-size: 16px;
}

.b-c {
  margin-right: 50px;
  margin-top: 37px;
  border: 1px solid #f6f6f6;
  -webkit-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  -moz-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  padding: 15px;
}

.sub-t {
  font-size: 18px;
  display: inline;
}

.i-f-s {
  width: 25px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

.c-f-g {
  background: #f3f3f3;
  border: none;
  padding: 2px;
  height: 40px;
}

.but-g {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  margin: 0 0 0 20px;
}
.but-g:hover {
  background: #14fc78;
}

.but-b {
  background: #000;
  color: #fff;
  border: 0;
  width: 200px;
  height: 40px;
  border-radius: 10px;
}
.but-b:hover {
  background: rgb(27, 27, 27);
}

.btn-f {
  margin: 0 40px 0 20px;
}

.f-r {
  float: right;
}

.s-o {
  background: #f3f3f3;
  border: none;
  font-family: "Open regular";
  font-size: 16px;
  padding: 5px;
  width: 200px;
}

.s-o option {
  padding: 5px;
}

.table {
  border: 1px solid #f6f6f6;
  text-align: center;
}
.btn-actions {
  background: #f6f6f6;
  border: none;
}
</style>
